export default (props, vars) => props?.['name'] === 'badge';
